import { motion } from "framer-motion";
import { ShieldCheck, Users, MapPinned, MessageCircle, PhoneCall, ListChecks } from "lucide-react";

const ITEMS = [
  { icon: Users, title: "Small curated groups", text: "Crews stay small on purpose — you're a name, not a seat number." },
  { icon: ShieldCheck, title: "Dedicated trip host", text: "Every drop has a Roamies host whose job is the group — logistics, energy, and making sure nobody eats alone." },
  { icon: ListChecks, title: "Clear itinerary", text: "You see the plan before you commit: what's included, what's not, and what each day looks like." },
  { icon: MessageCircle, title: "Group chat before arrival", text: "Meet the crew weeks before takeoff so day one feels like a reunion, not an introduction." },
  { icon: MapPinned, title: "Age verification (18–45)", text: "We ask every Roamie to confirm their age when joining, so the crew promise holds." },
  { icon: ShieldCheck, title: "Traveler screening", text: "Selected trips may include identity and safety screening before final confirmation. Screening is handled privately and subject to traveler consent and applicable requirements." },
  { icon: PhoneCall, title: "Emergency contact procedures", text: "Hosts collect emergency contact info before departure and share how to reach them during the trip." },
];

export const SafetySection = () => (
  <section className="py-16 sm:py-20 border-t border-ink/10" data-testid="safety-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6">
      <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mb-12">
        <p className="text-xs font-bold tracking-[0.2em] uppercase text-flame mb-4">Safety & Trust</p>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.95]">
          Travel solo.<br />Never feel alone.
        </h2>
      </motion.div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {ITEMS.map((item, i) => (
          <motion.div
            key={item.title}
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ delay: i * 0.06 }}
            data-testid={`safety-item-${i + 1}`}
            className="bg-white border border-black/10 p-7 hover:shadow-brutal hover:-translate-y-1 transition-all duration-300"
          >
            <item.icon className="w-6 h-6 text-flame" />
            <h3 className="font-display text-xl uppercase mt-4">{item.title}</h3>
            <p className="mt-2 text-sm text-ink/65 leading-relaxed">{item.text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
